import script from "./InsightsSources.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsSources.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__